import { getAuthHeaders, tempMeeApi } from '~/services/api';

export const postPermValuePropViewed = async (): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post<void>(
    '/posting-service/postings/perm-value-prop/viewed',
    {},
    { headers },
  );
};
